/**
 * WhatsApp deep-link helpers.
 *
 * Gallery's WhatsApp number is stored ONLY in REACT_APP_GALLERY_WHATSAPP
 * (env var) and is used purely as the `wa.me/<digits>` link target — it must
 * never be rendered as visible text anywhere in the public UI.
 */

// Strip a phone string ("+44 7931 649 145" / "+447931649145") to bare digits
// for use in https://wa.me/<digits>. Returns "" if input is empty/invalid.
export const toWaDigits = (phone) => {
  if (!phone) return '';
  return String(phone).replace(/\D+/g, '');
};

const GALLERY_WA = process.env.REACT_APP_GALLERY_WHATSAPP || '';

// Public-facing: a wa.me link to the gallery's WhatsApp.
export const galleryWhatsAppLink = (text = '') => {
  const digits = toWaDigits(GALLERY_WA);
  if (!digits) return null;
  const params = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${digits}${params}`;
};

// Admin: a wa.me link to a customer's number.
export const customerWhatsAppLink = (customerPhone, text = '') => {
  const digits = toWaDigits(customerPhone);
  if (!digits) return null;
  const params = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${digits}${params}`;
};
